import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { customerPaymentsAPI } from '../lib/api';

// Hook to get all customer payments for a company
export const useCustomerPayments = (companyId) => {
  return useQuery({
    queryKey: ['customerPayments', companyId],
    queryFn: () => customerPaymentsAPI.getAll(companyId),
    select: (response) => response.data?.Data || [],
    enabled: !!companyId,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};

// Hook to get payments for a specific customer
export const useCustomerPaymentsByCustomer = (companyId, customerId) => {
  return useQuery({
    queryKey: ['customerPayments', companyId, customerId],
    queryFn: () => customerPaymentsAPI.getByCustomer(companyId, customerId),
    select: (response) => response.data?.Data || [],
    enabled: !!companyId && !!customerId,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};

// Hook to create a new customer payment
export const useCreateCustomerPayment = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (paymentData) => customerPaymentsAPI.create(paymentData),
    onSuccess: (response, variables) => {
      // Invalidate and refetch customer payments
      queryClient.invalidateQueries({ queryKey: ['customerPayments'] });
      
      // Also invalidate customer data as payment might affect balances
      queryClient.invalidateQueries({ queryKey: ['customers'] });
      
      console.log('Customer payment created successfully:', response.data);
    },
    onError: (error) => {
      console.error('Error creating customer payment:', error);
    },
  });
};

// Hook to delete a customer payment
export const useDeleteCustomerPayment = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (paymentId) => customerPaymentsAPI.delete(paymentId),
    onSuccess: (response, paymentId) => {
      // Invalidate and refetch customer payments
      queryClient.invalidateQueries({ queryKey: ['customerPayments'] });
      
      // Also invalidate customer data as payment deletion might affect balances
      queryClient.invalidateQueries({ queryKey: ['customers'] });
      
      console.log('Customer payment deleted successfully:', paymentId);
    },
    onError: (error) => {
      console.error('Error deleting customer payment:', error);
    },
  });
};